import { PipeTransform } from '@angular/core';
var PhonePipe = /** @class */ (function () {
    function PhonePipe() {
    }
    PhonePipe.prototype.transform = function (value, format) {
        if (!value) {
            return '';
        }
        if (value.length !== 7 && value.length !== 10) {
            return value;
        }
        switch (format) {
            case 'parens':
                return value.length === 10
                    ? "(" + value.substr(0, 3) + ") " + value.substr(3, 3) + "-" + value.substr(6)
                    : value.substr(0, 3) + "-" + value.substr(3);
            case 'dash':
                return value.length === 10
                    ? value.substr(0, 3) + "-" + value.substr(3, 3) + "-" + value.substr(6)
                    : value.substr(0, 3) + "-" + value.substr(3);
            default:
                return value;
        }
    };
    return PhonePipe;
}());
export { PhonePipe };
